import React, { useState, useEffect } from 'react';

type Props = {
  children: React.ReactNode;
  waitBeforeShow?: number;
  skipDelay?: boolean
};

const Delayed = ({ children, waitBeforeShow = 500, skipDelay = false }: Props) => {
  const [isShown, setIsShown] = useState(false);

  useEffect(() => {
    if (skipDelay) {
      setIsShown(true);
      return;
    }

    const timeoutId = window.setTimeout(() => {
      setIsShown(true);
    }, waitBeforeShow);

    return () => window.clearTimeout(timeoutId);
  }, [skipDelay, waitBeforeShow]);

  return (
    <>
      {(skipDelay || isShown) && (
        children
      )}
    </>
  );
};

export default Delayed;
